import { brandedUuid } from '@multiplier/lib-shared-flavor';
export const ClientAccountIdSchema = brandedUuid('Invalid client account ID format');
//# sourceMappingURL=ClientAccountSchemas.js.map